/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import React from 'react';
import { LoadingIndicator } from '@/components/AZCustomComponent/LoadingIndicator';
import { NavBar } from '@/components/NavBar';
import styles from './styles.module.scss';

type DealsLoaderProps = {
  showBackButton?: boolean;
  showCloseButton?: boolean;
  handleBack?: () => void;
  handleClose?: () => void;
};

export const DealsLoader: React.FC<DealsLoaderProps> = ({
  showBackButton = false,
  showCloseButton = true,
  handleBack,
  handleClose,
}) => {
  return (
    <div className={styles.container}>
      <NavBar
        showBackButton={showBackButton}
        showCloseButton={showCloseButton}
        handleBack={handleBack}
        handleClose={handleClose}
      />
      <div className={styles.loadingWrapper}>
        <LoadingIndicator />
      </div>
    </div>
  );
};
